import { dataSender } from '../../../common/utils/router';
import { API_SERVER_URL, SITE_URL } from '../../../common/utils/utils';
import T from '../../../common/components/T';

export const getFormData = (
    formData,
    setAllowedSend,
    setFieldsErr,
    userToken,
    setComplet,
    setAlertData,
    lang,
    message,
    setAttempts
) => {
    dataSender(
        `${API_SERVER_URL}/api/v1/password/recover`,
        'POST',
        {
            ...formData,
            user_id: formData?.user_id?.id,
            url: `${SITE_URL}/store?pr=1`
        },
        () => setComplet(true),
        (data) => {
            setAttempts((prev) => ++prev);
            if (data.message) {
                setAlertData({ type: 'error', cont: data.message });
            }

            // if (data.errors.hasOwnProperty('g-recaptcha-response')) {
            //     router.reload(window.location.pathname);
            //     return;
            // }
            if (data?.errors['userBlocked']) {
                setAlertData({
                    type: 'error',
                    title: (
                        <T
                            textName='error_block_title'
                            defaultStr='Доступ к кабинету был временно заблокирован!'
                            page='/authentication'
                        />
                    ),
                    cont: (
                        <T
                            textName='error_block_text'
                            defaultStr='Обратитесь к администратору для выяснения причин блокировки'
                            page='/authentication'
                        />
                    )
                });
                return;
            }
            if (data.errors && Object.keys(data.errors) && !data.errors.hasOwnProperty('g-recaptcha-response')) {
                setFieldsErr(data.errors);
            }

            if (data.errors && data.errors.hasOwnProperty('g-recaptcha-response')) {
                setFieldsErr(data.errors);
                setAlertData({
                    type: 'error',
                    cont: data.errors['g-recaptcha-response']
                });
            }

            setAllowedSend(true);
        },
        userToken,
        lang,
        message
    );
};

export const getFormFields = (usersByEmail) =>
    [
        {
            attribute: 'login',
            required: true,
            title: {
                body: <T textName='getFormData-login-title-v1' defaultStr='Ваш ID или email' page='/authentication' />,
                links: false
            },
            name: 'email',
            type: 'input'
        },
        usersByEmail?.length
            ? {
                  required: true,
                  attribute: 'user_id',
                  title: {
                      body: (
                          <T
                              textName='getFormData-set-username-recovery-title'
                              defaultStr='Выберите аккаунт для восстановления пароля'
                              page='/authentication'
                          />
                      )
                  },
                  placeholder: (
                      <T
                          textName='getFormData-set-username-recovery-title'
                          defaultStr='Выберите аккаунт для восстановления пароля'
                          page='/authentication'
                      />
                  ),
                  type: 'dropdown',
                  options: usersByEmail
                      ? usersByEmail.map((i) => ({
                            id: i.id,
                            title: i.username
                        }))
                      : []
              }
            : false
    ].filter((i) => i != false);
